<template>
    <body :style="{height:cHeight()}">
    <div id="fix_header">
        <h2>
            <span style="font-size: 15px">{{count_appointments}}</span>&nbsp;
            <span v-if="!this.history">Live</span> Appointments
            &nbsp;
            <button class="button_history" @click.prevent="switchHistoryStatus">
                <i v-if="!this.history" class="fa fa-history" aria-hidden="true"></i>
                <i class="fa fa-calendar-check-o" aria-hidden="true" v-else></i>
            </button>
            <button class="button_back" @click.prevent="goback">&#11013;</button>
        </h2>
        <input v-if="count_appointments>0" type="text" id="searchInput" @keyup="searchAppointment()" placeholder="Filter by Office" title="Type name...">
    </div>
    <div v-if="count_appointments == 0">
        {{this.error_message}}
    </div>
    <div v-else style="overflow-x: auto">
        <table id="bmTable">
            <tr class="header">
                <th width="5%">Status</th>
                <th width="20%"><i class="fa fa-calendar" aria-hidden="true"></i> Date
                    <button class="button_history" @click.prevent="switchHistoryStatus">
                        <i v-if="!this.history" class="fa fa-history" aria-hidden="true"></i>
                        <i class="fa fa-calendar-check-o" aria-hidden="true" v-else></i>
                    </button>
                </th>
                <th width="10%"><i class="fa fa-clock-o" aria-hidden="true"></i> Time</th>
                <th width="28%"><i class="fa fa-commenting" aria-hidden="true"> Comment</i></th>
                <th width="15%">Office</th>
                <th width="10%"><i class="fa fa-map-marker" aria-hidden="true"></i> Location</th>
                <th width="7%">Client ID</th>
            </tr>
            <tr v-for="(appointment,index) in this.appointments " :key="appointment.index">
                <td>
                    <span v-if="!appointmentExpired(appointment.date,appointment.time)">
                        <button v-if="appointment.status === 0" class="text_btn request" style="background-color: cyan;color:black;cursor: pointer" @click.prevent="changeStatus(appointment.id,index)">
                            <i  class="fa fa-pencil-square-o" aria-hidden="true"></i>
                        </button>
                        <button v-else-if="appointment.status === 1" class="text_btn confirm">
                            <i  class="fa fa-check-circle" aria-hidden="true"></i>
                        </button>
                        <button  class="text_btn cancel" v-else>
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                    </span>
                    <span v-else>
                        <button v-if="appointment.status === 2" class="text_btn cancel">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                        <button  class="text_btn expired" v-else>
                            <i class="fa fa-hourglass-end" aria-hidden="true"></i>
                        </button>
                    </span>
                </td>
                <td>
                    <span :style="{fontWeight:'bold',fontSize:'12px', padding: '5px 5px', backgroundColor: setDateColor(appointment.date,appointment.time,appointment.status)}">
                        {{this.formatDate(appointment.date)}}
                    </span>
                </td>
                <td>{{appointment.time}}</td>
                <td style="font-size: 11px">{{extractComment(appointment.comment)}}</td>
                <td style="font-size: 11px">{{appointment.office}}</td>
                <td>{{appointment.location}}</td>
                <td v-if="!hasPformId(appointment.comment)">
                    <button class="text_btn warning" style="cursor: pointer" @click="showClient(appointment.hid)">
                        <i class="fa fa-user" aria-hidden="true"></i>
                    </button>
                </td>
                <td v-else>
                    <div v-for="pfid in hasPformId(appointment.comment)" :key="pfid.index">
                        <button class="text_btn warning" style="cursor: pointer" @click.prevent="showPetForm(pfid)" >&#128054;
                        </button>
                    </div>
                </td>
            </tr>
        </table>
        <!-- MOBILE TABLE -->
        <div id="mobileTable" v-for="(appointment,index) in this.appointments " :key="appointment.index">
            <div class="client_card" >
                <div class="client_card_container" >
                    <span class="statusIcon" v-if="!appointmentExpired(appointment.date,appointment.time)">
                        <span v-if="appointment.status === 1" class="text_btn confirm">
                            <i  class="fa fa-check-circle" aria-hidden="true"></i>
                        </span>
                        <span @click.prevent="changeStatus(appointment.id,index)" style="background-color: cyan;color:black;cursor: pointer" class="text_btn request" v-else-if="appointment.status === 0">
                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                        </span>
                        <span  class="text_btn cancel" v-else>
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </span>
                    </span>
                    <span class="statusIcon" v-else>
                        <span v-if="appointment.status === 2" class="text_btn cancel">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </span>
                        <span  class="text_btn expired" v-else>
                            <i class="fa fa-hourglass-end" aria-hidden="true"></i>
                        </span>
                    </span>

                    <span :style="{padding:'5px 5px', backgroundColor: setDateColor(appointment.date,appointment.time,appointment.status)}">{{appointment.date}}</span>

                    <span class="dtime"> {{ appointment.time }}</span>
                    <hr>

                    <span style="float: left">{{appointment.office}}</span>
                    <span >{{appointment.location}}</span>

                    <span v-if="!hasPformId(appointment.comment)" style="float: right;color: lime;" @click="showClient(appointment.hid)">
                        <i class="fa fa-user" aria-hidden="true"></i>
                    </span>
                    <span v-else>
                        <span v-for="pfid in hasPformId(appointment.comment)" :key="pfid.index">
                            <span  style="cursor: pointer" @click.prevent="showPetForm(pfid)" > &#128054;
                            </span>
                        </span>
                    </span>
                    <span style="float: right;padding-right: 8px" @click="showComment(extractComment(appointment.comment))">
                        <i class="fa fa-commenting" aria-hidden="true"></i>
                    </span>

                </div>
            </div>
            <br>
        </div>
    </div>
    <!-- status history -->
    <br>
    <div>
        <span class="text_btn confirm">
                <i  class="fa fa-check-circle" aria-hidden="true"></i><span style="font-size: 8px"> confirmed</span>
        </span>
        <span  class="text_btn request">
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i><span style="font-size: 8px">new</span>
            </span>
        <span  class="text_btn cancel">
                <i class="fa fa-times" aria-hidden="true"></i><span style="font-size: 8px"> rejected</span>
            </span>
        <span class="text_btn expired">
                <i class="fa fa-hourglass-end" aria-hidden="true"></i><span style="font-size: 8px"> expired</span>
            </span>
    </div>
    </body>
</template>
<script>
    import {getBaseURL} from '../url_endpoints.js'
    import {ulip_put} from '../https_requests.js'
    export default {
        name:'BAppointments',
        data() {
            return {
                appointments:[
                    /*
                    {
                        id:0,
                        hid:'dnan',
                        office:'test',
                        location:'Timisoara-Mall',
                        type:'work permit',
                        date:'21/11/2022',
                        time:'10:45',
                        status: 0,
                        comment:'bla bla',
                    },
                    {
                        id:0,
                        hid:'dnan',
                        office:'test',
                        location:'Timisoara-Mall',
                        type:'work permit',
                        date:'21/11/2022',
                        time:'10:45',
                        status: 0,
                        comment:'bla bla',
                    }*/
                ],
                offices:[],
                fix_header:null,
                sticky_zone:null,
                baseURL: null,
                error_message:'No appointments found!',
                history:true,
                live_appo:[],
            }
        },
        computed: {
            count_appointments() {
                return this.appointments.length
            },

        },
        mounted() {
            this.fix_header = document.getElementById('fix_header')
            this.sticky_zone = this.fix_header.offsetTop
            window.onscroll = () => this.setStickyHeader()
            // set back-end endpoints
            this.baseURL = getBaseURL()
            // get offices info from backend and then customer appointments
            this.getBusinessOffices()
        },
        methods:{
            cHeight() {
                let ch = this.appointments.length*10 + 50
                console.log("ch: "+ch)
                return ch+"vh"
            },
            showPetForm(pformid) {
                //console.log('Pet form id:',pformid)
                this.$router.push('/petfiles/'+pformid)
                window.scrollTo(0,0)
            },
            extractComment(comment) {
                if(!comment) return ''
                const ncomment = comment.split('pformid:')
                return ncomment[0]
            },
            hasPformId(comment) {
                if(!comment) return null
                const ncomment = comment.split('pformid:')
                if (ncomment.length > 1){
                    // has pform id
                    return ncomment[1].split('#')
                } else {
                    return null
                }
            },
            formatDate(datestring) {
                const d = new Date(datestring)
                const fd = d.toLocaleDateString('ro', { weekday:"long", month:"long", day:"numeric"})
                return fd
            },
            setDateColor(adate,atime,astatus) {
                if(astatus === 2) return 'grey'
                const flag = this.appointmentExpired(adate,atime)
                return flag ? 'lightcoral' : '#8BC47C'
            },
            appointmentExpired(adate,atime) {
                const d = adate.split('/')
                const t = atime.split(':')
                const appo = new Date(d[0],d[1]-1,d[2],t[0],t[1]) // -1 cause added before to show date +1
                let today = new Date()
                //console.log(today)
                //console.log(appo)
                return appo < today ? true : false
            },
            switchHistoryStatus() {
                // interchange history with appointments
                let temp = this.appointments
                this.appointments = this.live_appo
                this.live_appo = temp
                this.history = !this.history
            },
            changeStatus(appointment_id,index) {
                let status = 0
                const yes = prompt('Confirm or Reject requested appointment ?', 'confirm/reject')
                if(yes === 'confirm') {
                    status = 1
                }else {
                    if(yes === 'reject') {
                        status = 2
                    }
                }
                if(status > 0) {
                    ulip_put(this.baseURL,'/appointments',appointment_id,{status:status}) .then(() => {
                        //console.log('status updated ...'+rsp['id'])
                        this.appointments[index].status = status
                    }).catch(err => {
                        alert(err.message + '\nBackend Server could be down! Try again later..')
                    })
                }
            },
            goback() {
              this.$router.push('/features')
                window.scrollTo(0,0)
            },
            getBusinessOffices() {
                const business = this.$store.getters.getCurrentBusiness
                fetch(this.baseURL + '/offices?bid='+business.id).then(rsp => {
                    return rsp.json()
                }).then( response => {
                    //console.log(response)
                    for(let office of response) {
                        this.offices.push(office)
                    }
                    // store number of offices for current business
                    this.$store.commit('setNumberOffices',this.offices.length)
                    this.getBusinessAppointments()
                }).catch(err => {
                    alert(err.message+'\nBackend Server could be down!\nPlease try again later....')
                    //console.log('Error when get offices', err.message)
                })
            },
            getBusinessAppointments() {
                const business = this.$store.getters.getCurrentBusiness
                fetch(this.baseURL + '/appointments?bid='+business.id).then(rsp => {
                    return rsp.json()
                }).then( response => {
                    //console.log(response)
                    for(let a of response) {
                        let officedata = this.getOfficeInfo(a.office);
                        let appointment = {
                            id:a.id,
                            hid:a.hid,
                            office:officedata.name,
                            location:officedata.location,
                            type:officedata.type,
                            date:a.year+'/'+(a.month+1)+'/'+a.day ,
                            time:this.computeSlotString(a.slot),
                            status: a.status,//this.setStatus(a.year,a.month,a.day),
                            comment:a.comment,
                        }
                        this.addAppointmentByDate(appointment)
                    }
                    this.$store.commit('setLiveAppointments',this.appointments.length)
                    // compute history table
                    for(let appo of this.appointments) {
                        if(!this.appointmentExpired(appo.date,appo.time)){
                            this.live_appo.push(appo)
                        }
                    }
                    //console.log(this.live_appo)
                }).catch(err => {
                    alert(err.message+'\nBackend Server not working!\nPlease try again later....')
                    this.error_message = 'Backend Server could be down!'
                    //console.log('Error when get appointments', err.message)
                })
            },
            showComment(comment) {
                alert('Client comment:\n'+comment)
            },
            showClient(id) {
                alert('The customer who requested the appointment has the following \nKey Access Code:\n' + id)
                //console.log(index)
            },
            setStickyHeader() {
                if(window.pageYOffset > this.sticky_zone){
                    this.fix_header.classList.add('sticky_header')
                } else {
                    this.fix_header.classList.remove('sticky_header')
                }
            },
            searchAppointment() {
                let input, filter, table, tr, td, txtValue
                input = document.getElementById("searchInput")
                filter = input.value.toUpperCase()
                table = document.getElementById("bmTable")
                tr = table.getElementsByTagName("tr")
                for(let i = 0; i < tr.length; i++) {
                    td = tr[i].getElementsByTagName("td")[4] // get Office name
                    if (td) {
                        txtValue = td.textContent || td.innerText
                        if (txtValue.toUpperCase().indexOf(filter) > -1) {
                            tr[i].style.display = ""
                        } else {
                            tr[i].style.display = "none"
                        }
                    }
                }
            },
            getOfficeInfo(index){
                let officedata ={
                    name:'',
                    location:'',
                    type:''
                }
                for(let o of this.offices) {
                    if(o.id === index) {
                        officedata = {
                            name: o.name,
                            location: o.location,
                            type: o.type,
                        }
                    }
                }
                return officedata
            },
            computeSlotString(slot) {
                //console.log(slot)
                let slotmodel = '00:00'
                let time_minutes = slot.split(':')
                if(time_minutes[0].length == 1) {
                    slotmodel = '0'+ time_minutes[0] +':'
                } else {
                    slotmodel = time_minutes[0] + ':'
                }
                if(time_minutes[1].length == 1) {
                    slotmodel = slotmodel + '0' + time_minutes[1]
                } else {
                    slotmodel = slotmodel + time_minutes[1]
                }
                return slotmodel
            },
            addAppointmentByDate(appointment) {
                // compare appointment date with first element of array
                let endinsert = true
                if(this.appointments.length === 0) {
                    this.appointments.push(appointment)
                } else {
                    const in_date = new Date(appointment.date)
                    // search position to insert
                    for(let i = 0; i< this.appointments.length; i++ ) {
                        let i_from_array = this.appointments[i].date
                        let idate = new Date(i_from_array)
                        if (in_date > idate) {
                            //console.log('pass')
                        } else {
                            // insert
                            this.appointments.splice(i,0,appointment)
                            endinsert = false
                            break;
                        }
                    }
                    if(endinsert) {
                        this.appointments.push(appointment)
                    }
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    * {
        box-sizing: border-box;
    }
    #searchInput {
        background-image: url('../assets/search_icon_25.png');
        background-position: 5px 5px;
        background-repeat: no-repeat;
        width: 30%;
        font-size: 12px;
        padding: 10px 20px 10px 40px;
        border: 1px solid #ddd;
        margin-bottom: 12px;
    }
    #bmTable {
        border-collapse: collapse;
        width: 100%;
        border: 1px solid #ddd;
        font-size: 15px;
    }

    #bmTable th, #bmTable td {
        text-align: left;
        //background-color: #000000;
        padding: 12px;
    }

    #bmTable tr {
        border-bottom: 1px solid #ddd;
        //opacity: 0.7;
    }
    #bmTable tr.header {
        background-color: lightseagreen;
    }

    #bmTable tr:hover {
        background-color: darkslategrey;
        color:white;
    }
    // ******************** round button
    .button_home {
        background-color: white;
        color: black;
        border: none;
        padding: 5px 5px;
        font-size: 14px;
        font-family: Raleway;
        cursor: pointer;
        border-radius: 10px;
        opacity: 0.8;
        margin-left: 5px;
    }
    .button_home:hover {
        opacity: 1.0;
    }
    .button_back {
        @extend .button_home;
        float: left;
    }
    //history button
    .button_history {
        @extend .button_home;
        background-color: linen;
        padding: 5px 12px;
        color: crimson;
    }
    .button_history:hover {
        opacity: 1.0;
        //border: groove;
    }
    // add sticky header of this wiew
    .sticky_header {
        position: fixed;
        top:0;
        left:0;
        width: 100%;
        background-color: #2c3e50;
        z-index: 1;
    }
    // import text buttons styles
    @import "../assets/css/text_buttons";
    @import "../assets/css/appointments_mobile";
</style>